import React from 'react';
import { Eye, ShoppingBag, Sparkles } from 'lucide-react';

export const StudioHeader = ({ session, history, hardCartLength, onGalleryOpen, onCartOpen }) => {
  const tryOnResults = history.filter((h) => h.type === 'tryon' || h.type === 'moment');
  const remaining = session ? (session.max_tryons || 5) - (session.tryons_used || 0) : 0;

  const remainingColorClass =
    remaining === 0
      ? 'text-slate-400 bg-slate-100'
      : remaining === 1
      ? 'text-red-600 bg-red-50'
      : remaining === 2
      ? 'text-amber-600 bg-amber-50'
      : 'text-slate-600 bg-slate-100';

  const sparkleColor = remaining <= 0 ? 'text-slate-300' : remaining <= 2 ? 'text-amber-500' : 'text-amber-500';

  return (
    <header className="sticky top-0 z-40 flex-shrink-0 px-3 sm:px-4 py-2 sm:py-3 flex items-center justify-between border-b border-slate-100 bg-white">
      <div className="w-10" />

      {session && (session.partner_logo_url || session.partner_name) && (
        <div className="flex items-center gap-2.5">
          {session.partner_logo_url && (
            <img
              src={session.partner_logo_url}
              alt={session.partner_name || 'Partner'}
              className="h-10 w-auto object-contain rounded"
            />
          )}
          {session.partner_name && (
            <span className="text-base font-bold text-slate-800">{session.partner_name}</span>
          )}
        </div>
      )}

      <div className="flex items-center gap-2">
        {tryOnResults.length > 0 && (
          <button
            onClick={onGalleryOpen}
            className="flex items-center gap-1.5 text-xs text-slate-600 bg-slate-100 px-2.5 py-1.5 rounded-full hover:bg-slate-200 transition-colors"
            data-testid="my-looks-button"
            title="View your session gallery"
          >
            <Eye className="w-3.5 h-3.5" />
            <span className="font-medium">My Looks</span>
            <span className="w-4 h-4 bg-slate-400 text-white rounded-full flex items-center justify-center text-[10px] font-bold">
              {tryOnResults.length}
            </span>
          </button>
        )}

        <button
          onClick={onCartOpen}
          className={`flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-full transition-colors ${
            hardCartLength > 0
              ? 'text-blue-700 bg-blue-100 hover:bg-blue-200'
              : 'text-blue-600 bg-blue-50 hover:bg-blue-100'
          }`}
          data-testid="cart-button"
          title="View cart"
        >
          <ShoppingBag className="w-3.5 h-3.5" />
          <span className="font-medium">Cart</span>
          {hardCartLength > 0 && (
            <span className="w-4 h-4 bg-blue-600 text-white rounded-full flex items-center justify-center text-[10px] font-bold">
              {hardCartLength}
            </span>
          )}
        </button>

        {session && (
          <div
            className={`flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-full select-none ${remainingColorClass}`}
            title={`${remaining} try-on${remaining !== 1 ? 's' : ''} remaining`}
            data-testid="tryons-remaining"
          >
            <Sparkles className={`w-3.5 h-3.5 ${sparkleColor}`} />
            <span>
              <span className="font-bold">{remaining}</span> left
            </span>
          </div>
        )}
      </div>
    </header>
  );
};
